import {Component, EventEmitter, HostListener, Input, Output, Renderer2} from '@angular/core';

@Component({
  selector: 'app-rippler-drop-down',
  templateUrl: './drop-down.component.html',
  styleUrls: ['./drop-down.component.scss']
})

export class RipplerDropDownComponent {
  viewHide = false;
  clickOnButton = false;
  defaultText = '';
  @Input() keyField = '';
  @Input() dataList: any;
  @Input() placeholderText = 'Select Server';
  @Input() isProfile = false;
  @Input() profileObj: any;
  @Input() style = 'rounded';
  @Input() isDisabled = false;
  @Input() iconStyle = 'right';
  @Input() size = '';
  @Output() dataSet: EventEmitter<any> = new EventEmitter<any>();

  constructor(private renderer: Renderer2) {
    this.renderer.listen('window', 'click', (e: Event) => {
      if (!this.clickOnButton) {
        this.viewHide = false;
      }
      this.clickOnButton = false;
    });
  }

  showHideList() {
    if (!this.isDisabled) {
      this.viewHide = !this.viewHide;
    }
  }

  activateList() {
    this.clickOnButton = true;
  }

  setData(data: any) {
    this.placeholderText = this.keyField ? data[this.keyField] : data;
    this.defaultText = this.keyField ? data[this.keyField] : data;
    this.dataSet.emit(data);
  }

  setClass() {
    let dropDownStyle = '';
    if (this.style === 'rounded') {
      dropDownStyle = 'round';
    }
    if (this.style === 'pill') {
      dropDownStyle = 'pill';
    }
    if (this.style === 'text') {
      dropDownStyle = dropDownStyle + ' ' + 'text';
    }
    if (this.size === 'flex') {
      dropDownStyle = dropDownStyle + ' ' + 'flex-width';
    }
    if (this.size === 'normal-height') {
      dropDownStyle = dropDownStyle + ' ' + 'normal-height';
    }
    if (this.size === 'large-normal-height') {
      dropDownStyle = dropDownStyle + ' ' + 'large-normal-height';
    }
    if (this.size === 'flex-normal-height') {
      dropDownStyle = dropDownStyle + ' ' + 'flex-normal-height';
    }
    if (this.size === 'large') {
      dropDownStyle = dropDownStyle + ' ' + 'large-width';
    }
    if (this.size === 'small') {
      dropDownStyle = dropDownStyle + ' ' + 'small';
    }
    if (this.size === 'small-large') {
      dropDownStyle = dropDownStyle + ' ' + 'small-large';
    }
    if (this.size === 'small-flex') {
      dropDownStyle = dropDownStyle + ' ' + 'small-flex';
    }
    if (this.isDisabled) {
      dropDownStyle = dropDownStyle + ' ' + 'disabled';
    }

    if (this.iconStyle === 'right') {
      dropDownStyle = dropDownStyle + ' ' + 'align-end';
    }
    return dropDownStyle;
  }

  setSpanClass() {
    if (this.size === 'flex' || this.size === 'flex-normal-height') {
      return 'flex-width';
    }
    if (this.size === 'large' || this.size === 'large-normal-height') {
      return 'large-width';
    }
    if (this.size === 'small' || this.size === 'small-large' || this.size === 'small-flex') {
      return 'small-ht';
    }
    return '';
  }
}
